<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_8865_1271)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.57556 7.57592C7.34127 7.81026 7.34136 8.19012 7.57575 8.42435C7.81015 8.65859 8.19009 8.6585 8.42438 8.42416L13.7989 3.04843L13.7989 7.39756C13.7989 7.72889 14.0676 7.99749 14.399 7.99749C14.7304 7.99749 14.999 7.72889 14.999 7.39756V1.59994C14.999 1.2686 14.7304 1 14.399 1H8.60005C8.26864 1 7.99999 1.2686 7.99999 1.59994C7.99999 1.93127 8.26864 2.19987 8.60005 2.19987H12.9504L7.57556 7.57592Z"
        fill="currentColor"
      />
      <path
        d="M14.5 11V13.5C14.5 14.0523 14.0523 14.5 13.5 14.5H2.5C1.94772 14.5 1.5 14.0523 1.5 13.5V2.5C1.5 1.94772 1.94772 1.5 2.5 1.5H5"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8865_1271">
        <rect
          width="16"
          height="16"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
